export enum Roles {
  CUSTOMER = 'customer',
  ADMIN = 'admin',
  SUPER_USER = 'super_user',
  SUPER_ADMIN = 'super_admin',
}

export interface CurrentUser {
  id: string
  firstName: string
  lastName: string
  username: string
  email: string
  phone: string
  role: Roles
  organizationId: string | null
  deactivatedAt: null | string
}

export enum NotificationStatuses {
  CREATED = 'created',
  SEEN = 'seen',
}

export enum NotificationTypes {
  NEWSCAST_PRODUCTION = 'newscastProduction',
}

export interface UserNotification {
  id: string
  status: NotificationStatuses
  type: NotificationTypes
  text: string
  user: User
}

export interface User {
  id: string
  firstName: string
  lastName: string
  username: string
  email: string
  role: Roles
  initialRole?: Roles
  deactivatedAt: null | string
  recoveryCode?: null | string
  createdAt?: string
  notifications?: []
}

export interface CreateUserPayload {
  username: string
  firstName: string
  lastName: string
  email: string
  password: string
  role: Roles
}

export interface UpdateUserPayload {
  fullname?: string
  email?: string
  password?: string
  role?: Roles
  recoveryCode?: number
}

export interface InviteUserPayload {
  email: string
}
